import React from "react";
import styles from './article.module.less';

import thumbIMG from '../../article-thumbs/article-thumb.jpg';
import { NavLink } from "react-router-dom";
function Article(props)
{
    let article = props.value;
    return (
        <NavLink to={`/Articles/${article.id}`} className={styles.article}>
            <div>
                <div className={styles.imageWrapper}>
                    <img src={article.imageURI} />
                </div>
                <div className={styles.description}>
                    <h3>
                        {article.title}
                    </h3>
                    <p>{article.description}</p>
                </div>
            </div>
        </NavLink>
    );
}

export default Article;